export default __webpack_public_path__ + "static/media/AKM_4.45e332c3.png";